module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Arrow_up_Black.c287d6d9.svg";